import { toast } from "react-toastify";
import { LogOut } from "../Redux/Actions/index"; 
import { store } from "../Redux/Store/index";

export function handleError(error, config = {}) {
  toast(error.message || "Erro inesperado", {
    position: "top-center",
    type: "error",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: config.theme || "light",
  });

  if (error.status === 401) {
    store.dispatch(LogOut());
  }
}